import { useDispatch, useSelector } from "react-redux";

export default function IncomingCallOverlay({ onAccept,onDecline }) {
    const dispatch = useDispatch();
    const call = useSelector(state => state.call.incomingCall);

    if (!call) return null;

    

    return (
        <div style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.75)",
            backdropFilter: "blur(12px)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
        }}>
            <div style={{ color: "white", fontSize: "22px", marginBottom: "20px" }}>
                📞 {call.fromUserName || "Quelqu’un"} vous appelle...
            </div>

            <div style={{ display: "flex", gap: "20px" }}>
                <button
                    onClick={ onAccept }
                    style={{
                        padding: "14px 28px",
                        background: "#3ecf5e",
                        color: "white",
                        borderRadius: "50px",
                        fontSize: "18px"
                    }}>
                    Décrocher
                </button>

                <button
                    onClick={onDecline}
                    style={{
                        padding: "14px 28px",
                        background: "#e63939",
                        color: "white",
                        borderRadius: "50px",
                        fontSize: "18px"
                    }}>
                    Refuser
                </button>
            </div>
        </div>
    );
}
